import React from 'react';

// Styles & Assets
import styles from './StopsRoute.module.css';

// Components
import Stop from '../Stop/Stop';
import DraggableList from '../../UI/DraggableList/DraggableList';

// Language
import { useTranslation } from 'react-i18next';

// Other
import { DropResult } from 'react-beautiful-dnd';
import { Patient } from '../../../interfaces/Patient';

const StopsRoute: React.FC<{
    sortedPatients: Patient[],
    reorderWaypoints: (indexS: number, indexD: number) => void
    handleDeleteWaypoint: (index: number) => void
}> = ({ sortedPatients, reorderWaypoints, handleDeleteWaypoint }) => {

    const { t } = useTranslation();



    const handleOnDragEnd = (result: DropResult) => {

        if (result.destination === null || result.destination === undefined) return;
        const indexS = result.source.index;
        const indexD = result.destination.index;

        reorderWaypoints(indexS, indexD);

    };


    return (
        <div className={styles.stopsContainer}>
            <h2 className={styles.stopsTitle}>{t('stops')}</h2>
            {!sortedPatients || sortedPatients.length === 0 ?
                null
                :
                <div className={styles.listContainer}>
                    <DraggableList
                        onDragEnd={handleOnDragEnd}
                        droppableId='stops'
                        orderedList={sortedPatients}
                    >
                        {(item, index, dragHandleProps) =>
                            <div {...dragHandleProps}>
                                <Stop
                                    patient={item}
                                    index={index}
                                    handleDeleteStop={handleDeleteWaypoint}
                                />
                            </div>
                        }
                    </DraggableList>
                </div>
            }
        </div >
    );
};

export default StopsRoute;